import * as _ from "lodash";
import * as React from "react";
import { useEffect, useRef } from "react";

interface SearchFilterGroupProps {
    columnOptions: ISelectColumn[];
    isOpen: boolean;
    closeHandler: Function;
    clickHandler: Function;
}

export interface ISelectColumn {
    value: string;
    isEnabled: boolean;
    isSelected: boolean;
}

export default function SelectColumns({
    columnOptions,
    isOpen,
    closeHandler,
    clickHandler,
}: SearchFilterGroupProps) {
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                containerRef.current &&
                !containerRef.current.contains(event.target as Node)
            ) {
                closeHandler();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [closeHandler]);

    const handleClick = (col: ISelectColumn) => {
        if (col.isEnabled) {
            clickHandler(col);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="columnlist" ref={containerRef}>
            <ul>
                {columnOptions.map((col, i) => (
                    <li key={i} onClick={() => handleClick(col)}>
                        <input
                            type="checkbox"
                            checked={col.isSelected}
                            disabled={!col.isEnabled}
                            onChange={() => {}} // Prevent warning, but noop
                        />
                        {col.value}
                    </li>
                ))}
            </ul>
        </div>
    );
}
